export default {
  methods: {
    handelClick: function handelClick(e) {
      this.$emit('click', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        handelClick = this.handelClick;

    return h(
      'div',
      {
        on: {
          'click': handelClick
        }
      },
      [$slots['default']]
    );
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ant-design-vue/es/table/FilterDropdownMenuWrapper.js
// module id = 867
// module chunks = 0